import React from 'react'
import { __, getLanguage } from '../lib/helpers'
import 'isomorphic-fetch'

const propTypes = {
  showForm: React.PropTypes.string.isRequired,
  setShowForm: React.PropTypes.func.isRequired,
  mode: React.PropTypes.string.isRequired,
  selectedEntity: React.PropTypes.object,
}

class MasterForm extends React.Component {

  constructor(props) {
    super(props)

    this.handleCloseClick = this.handleCloseClick.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.state = {
      isSending: false,
    }
    
  }
    
  componentDidMount() {
    this.eco.checked = 'checked'
    this.photovoltaics.checked = 'checked'
  }

  handleCloseClick(event) {
    this.props.setShowForm(false)
  }

  resetInput() {
    this.salutation.value = ''
    this.firstname.value = ''
    this.lastname.value = ''
    this.email.value = ''
    this.phone.value = ''
    this.energy.value = ''
    this.eco.checked = 'checked'
    this.photovoltaics.checked = 'checked'
    this.gdpr.checked = false
  }
  
  handleSubmit = (e) => {
    e.preventDefault()

    this.setState({
      isSending: true,
    })
    
    let serialize = require('form-serialize')
    let form = document.querySelector('.MasterFormElements')
    let postData = serialize(form)
    
    let productInterest__c = []
    if (this.eco.checked) {
      productInterest__c.push('eco')
    }
    if (this.photovoltaics.checked) {
      productInterest__c.push('Photovoltaics')
    }
    
    if ( productInterest__c != '' ) { postData += '&productInterest__c=' + productInterest__c.join('%3B') }
    
    postData += '&LeadType__c=Customer'
    postData += '&ApiCampaign__c=70124000000OAvl'
    postData += '&leadsource=Web'
    postData += '&awarenessSource__c=sonnenCommunity%20live'
    postData += '&language__c='+getLanguage().toUpperCase()
    postData += '&awarenessSourceDetails__c='+this.props.mode
    
    let clickedAmbassador = ''  
    if (this.props.selectedEntity) {
      if (this.props.selectedEntity.ambassador) {
        // clickedAmbassador = 'Preferred sonnenAmbassador: ' + this.props.selectedEntity.ambassador.name
                
        let today = new Date()
        let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
        
        clickedAmbassador = '-%20m%C3%B6chte%20Kontakt%20zu%20einem%20sonnenBotschafter%20%0D%0A-%20gew%C3%BCnschter%20sonnenBotschafter%3A%20' + this.props.selectedEntity.ambassador.name + '%20%0D%0A-%20bitte%20sonnenBotschafter%20Interesse%20nochmal%20best%C3%A4tigen%20lassen%0D%0A-%20Formular%20abgesendet%20am%3A%20' + date
  
      }
    }
    
    if ( clickedAmbassador != '' ) { postData += '&message__c=' + clickedAmbassador } else { postData += '&message__c=null' }
      
    // console.log( postData )
    
    let _this = this

    fetch(
      'https://go.pardot.com/l/317971/2017-07-04/8dds',
      {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': '*/*'
        },
        body: postData
      }
    )
    .then(function(result) { 
      //console.log( 'Result: ', result )
      
      _this.setState({
        isSending: false,
      })
              
      document.getElementById('MasterFormSuccess').style.opacity = 1
      setTimeout(function() { document.getElementById('MasterFormSuccess').style.opacity = 0 }.bind(this), 5000)
      setTimeout(function() { _this.props.setShowForm(false) }.bind(this), 5000)
      setTimeout(function() { _this.resetInput() }, 5000)
      
    })
    .catch(function (error) {
      //console.log('Request failed:', error)
      _this.setState({
        isSending: false,
      })
      document.getElementById('MasterFormError').style.opacity = 1
      setTimeout(function() { document.getElementById('MasterFormError').style.opacity = 0 }.bind(this), 5000)
    })
    
  }

  render() {
    const classMasterForm = (this.props.showForm == true)
      ? 'MasterForm MasterForm--visible'
      : 'MasterForm MasterForm--hidden'

    const buttonSubmit = (this.state.isSending)
      ? <button id="formButton" type="submit" tabindex="11" disabled>{ __('MasterForm.submit') }</button>
      : <button id="formButton" type="submit" tabindex="11">{ __('MasterForm.submit') }</button>

    return (
      <div className={classMasterForm}>
        <div className="MasterFormContainer">
          <h3>{ __('MasterForm.title') }</h3>
          <button onClick={this.handleCloseClick} className="MasterFormClose">
            <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMiAyMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiMxODFhMjc7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5zb25uZW5fdWlfY2xvc2Vmb3JtPC90aXRsZT48ZyBpZD0iRWJlbmVfMiIgZGF0YS1uYW1lPSJFYmVuZSAyIj48ZyBpZD0iRWJlbmVfMS0yIiBkYXRhLW5hbWU9IkViZW5lIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTEyLjQxLDExbDkuMjktOS4yOUExLDEsMCwwLDAsMjAuMjkuMjlMMTEsOS41OSwxLjcxLjI5QTEsMSwwLDAsMCwuMjksMS43MUw5LjU5LDExLC4yOSwyMC4yOWExLDEsMCwxLDAsMS40MSwxLjQxTDExLDEyLjQxbDkuMjksOS4yOWExLDEsMCwwLDAsMS40MS0xLjQxWiIvPjwvZz48L2c+PC9zdmc+" />
          </button>
          <form onSubmit={this.handleSubmit} className="MasterFormElements">
            <span id="personalInformation">{ __('MasterForm.personalInformation') }</span>
            <br />
            <fieldset className="fieldSetName">
              <label className="MasterForm-Sets MasterForm-Salutation">
                <span className="MasterForm-Label">
                  { __('MasterForm.salutation') }*
                </span>
                <br />
                <select id="salutation" name="salutation" tabindex="1" required autofocus ref={(salutation) => this.salutation = salutation}>
                  <option value="" disabled selected>
                    
                  </option>
                  <option value="Mr.">{ __('MasterForm.male') }</option>
                  <option value="Ms.">{ __('MasterForm.female') }</option>
                </select>
            </label>
            <label className="MasterForm-Sets MasterForm-Firstname">
              <span className="MasterForm-Label">
                { __('MasterForm.firstname') }*
              </span>
              <br />
              <input id="firstname" name="firstname" type="text" placeholder="" tabindex="2" required ref={(firstname) => this.firstname = firstname} />
            </label>
            <label className="MasterForm-Sets MasterForm-Lastname">
              <span className="MasterForm-Label">
                { __('MasterForm.lastname') }*
              </span>
              <br />
              <input id="lastname" name="lastname" type="text" placeholder="" tabindex="3" required ref={(lastname) => this.lastname = lastname} />
            </label>
            </fieldset>
            <fieldset className="mailPhoneEnergy">
              <label className="MasterForm-Sets MasterForm-Email">
                <span className="MasterForm-Label">
                  { __('MasterForm.email') }*
                </span>
                <br />
                <input id="email" name="email" type="email" placeholder="" tabindex="4" required pattern="[A-Za-z0-9._%+-]{2,}@[a-zA-Z]{1,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,4})" ref={(email) => this.email = email} />
              </label>
              <label className="MasterForm-Sets MasterForm-Phone">
                <span className="MasterForm-Label">
                  { __('MasterForm.phone') }*
                </span>
                <br />
                <input id="phone" name="phone" type="tel" placeholder="" tabindex="5" required ref={(phone) => this.phone = phone} />
              </label>
              
            </fieldset>
            <fieldset className="checkBoxes">
              <label className="energyConsumption">
                <span className="MasterForm-Label">
                  { __('MasterForm.energyConsumption') }
                </span>
                <input id="energy" name="EnergyConsumption__c" type="number" placeholder={ __('MasterForm.ecPlaceholder') } tabindex="6" min="0" max="50000" step="100" ref={(energy) => this.energy = energy} />
              </label>
                {/* <span id="opening">{ __('MasterForm.subject') }</span><br /><br /> */}
              <label className="infoCheckboxFirst">
                <input type="checkbox" tabindex="7" ref={(eco) => this.eco = eco} />
                <span id="checkBoxCorrection">{ __('MasterForm.sonnenBatterie') }</span>
              </label>
              <br />
              <label>
                <input type="checkbox" tabindex="8" ref={(photovoltaics) => this.photovoltaics = photovoltaics} />
                <span id="checkBoxCorrection">{ __('MasterForm.pvAnlage') }</span>
              </label>
              <br />
            </fieldset>
            <fieldset className="gdprCheckbox">
              <span className="MasterForm-Label gdprHeadline">{ __('MasterForm.gdprHeadline') }</span>
              <label>
                <input type="checkbox" tabindex="9" required ref={(gdpr) => this.gdpr = gdpr} />
                <span id="gdprText">{ __('MasterForm.gdprCheckbox') }</span>
              </label>
            </fieldset>
            <fieldset className="buttonField">
              {buttonSubmit}
            </fieldset>
          </form>
          <div className="MasterForm-Legal">{ __('MasterForm.requiredFields') }</div>
          <div className="MasterFormSuccess" id="MasterFormSuccess">{ __('MasterForm.successMessage') }</div>
          <div className="MasterFormError" id="MasterFormError">{ __('MasterForm.errorMessage') }</div>
        </div>
      </div>
    )
  }
}

MasterForm.propTypes = propTypes

export default MasterForm


// WEBPACK FOOTER //
// ./src/components/MasterForm.js